// extracted by mini-css-extract-plugin
module.exports = {"cont-tab":"MyPageGoodsTabs_cont-tab__1KS--","btn-tab":"MyPageGoodsTabs_btn-tab__Qh_6z","bar":"MyPageGoodsTabs_bar__2jmw5"};